<template>
  <b-modal
    :id="modalRefName"
    :ref="modalRefName"
    no-close-on-esc
    no-close-on-backdrop
    static
    centered
    scrollable
    size="lg"
    :visible="status"
    v-bind="$attrs"
    class="base-popover"
    @close="$emit('close')"
  >
    <template #modal-title>
      <slot name="title" />
    </template>

    <template #default>
      <slot name="default" />
    </template>

    <template #modal-footer>
      <slot name="footer" />
    </template>
  </b-modal>
</template>

<script>
	export default {
		props: {
			modalRefName: {
				type: String,
				required: true
			},
			status: {
				type: Boolean,
				required: true,
				default: false
			}
		},
		watch: {
			status() {
				if (this.status) {
					this.$refs[this.modalRefName].show();
				} else {
					this.$refs[this.modalRefName].hide();
				}
			}
		},
		mounted() {
			this.$refs[this.modalRefName].$on("shown", () => {
				// Remove onbeforeunload
				window.onbeforeunload = null;
			});

			this.$refs[this.modalRefName].$on("hidden", () => {
				if (this.savingDocument === false && process.env.NODE_ENV === "production") {
					// Setup onbeforeunload
					window.onbeforeunload = function () {
						return "Êtes-vous sûrs de vouloir fermer la page?";
					};
				}

				this.$emit("update:status", false);
			});
		},
		destroyed() {
			this.$emit("update:status", false);
		}
	};
</script>

<style lang="scss">
	.base-popover {
		.b-overlay.position-absolute {
			margin: 0 0 0 -32px;
		}

		.modal-dialog {
			& .btn-choice {
				background: var(--white);
				color: black;
				cursor: pointer;
				border: 1px solid;
				box-sizing: border-box;
				box-shadow: 0px 4px 12px rgba(20, 85, 224, 0.14);
				border-radius: 7px;
				padding: 0px;
				height: auto;
				width: auto;

				&:hover {
					background: rgba(20, 85, 224, 0.14);
					color: black;
				}

				p {
					font-weight: 500;
					font-size: 12px;
					line-height: 18px;
					letter-spacing: 0.01em;
					color: var(--black);
				}
			}

			& .btn-action {
				width: 100%;
				height: 32px;
				border-radius: 4px;
				font-size: 13px;
				line-height: 19px;
				text-align: center;
				letter-spacing: 0.01em;
				margin-bottom: 8px;
			}

			& .modal-content {
				background: var(--white);
				border: 1px solid var(--border);
				box-sizing: border-box;
				box-shadow: 0px 0px 70px gba(51, 77, 110, 0.31);
				border-radius: 20px;
				padding: 40px 50px 25px 50px;
        max-height: 95%;
			}

			& .modal-header {
				border: none;
				padding: 0;

				& .close {
					padding: 0;
				}
			}

			& .modal-title {
				font-style: normal;
				font-weight: 500;
				font-size: 19px;
				line-height: 28px;
				letter-spacing: 0.01em;
				color: var(--black) !important;
				margin-bottom: 30px;
			}

			& .modal-body {
				padding: 0 15px 0 15px;
			}

			& .modal-footer {
				padding: 0;
				border: none;
			}
		}
	}

  @media (max-width: 576px) {
    .base-popover .modal-dialog .modal-content {
      padding: 20px 16px 25px 16px;
    }
  }

  @media (min-width: 768px) {
    .base-popover .modal-dialog .modal-content  {
      padding: 40px 50px 25px 50px;
    }
  }
</style>
